class IntroGIF {

  constructor() {
    this.animationDuration = 8000;
    this.introContainer = document.querySelector(".intro-container");
    this.introGIF = this.introContainer.querySelector("img");
    this.subtitle = this.introContainer.querySelector("p");
    this.timer = null;
  }

  show() {
    // Reload the source to make sure the GIF plays from the start
    const gifURL = this.introGIF.src;
    this.introGIF.src = '';
    this.introGIF.src = gifURL;
    this.introContainer.style.opacity = 1;
    this.subtitle.style.opacity = 0.5;
    this.introContainer.style.pointerEvents = "auto";
    this.introContainer.style.cursor = "pointer";
    this.introContainer.addEventListener("click", ()=>{
        this.onContainerClick()
    });
    this.timer = window.setTimeout(() => {
      this.onGIFComplete();
    }, this.animationDuration);
  }

  onContainerClick() {
    if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
    }
    this.onGIFComplete();
  }

  onGIFComplete() {
    this.sendEvent("introCompleted");
    this.introContainer.style.pointerEvents = "none";
    this.subtitle.style.opacity = 0;
    this.introContainer.removeEventListener("click", () => {
      this.onContainerClick();
    });
  }

  hide() {
    this.introContainer.style.opacity = 0;
    window.setTimeout(()=>{
      if(this.introContainer){
        this.introContainer.remove()
      }
    },200)
  }

  sendEvent(eventName) {
    const event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    document.dispatchEvent(event);
  }

}

export { IntroGIF };
